import { colors, Icon, Tooltip } from '@dev-spendesk/grapes';
import classNames from 'classnames';
import { useMemo } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  value: string | undefined;
};

const MAX_TEXT_LENGTH = 42;

export const MappedValue = ({ value }: Props) => {
  const { t } = useTranslation('global');
  const icon = value ? ('link' as const) : ('triangle-warning' as const);
  const iconColor = value
    ? colors.contentPrimary
    : colors.contentWarningDefault;
  const textValue = value ?? t('costCenters.unmapped');

  const toolTipWidth = useMemo(() => {
    if (textValue.length < 10) {
      return undefined;
    }

    return textValue.length * 10;
  }, [textValue]);

  const displayText = useMemo(() => {
    return textValue.length > MAX_TEXT_LENGTH
      ? `${textValue.slice(0, MAX_TEXT_LENGTH)}...`
      : textValue;
  }, [textValue]);

  return (
    <div className="flex items-center">
      <Icon name={icon} size="m" color={iconColor} />
      <div
        className={classNames('pl-8', {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'text-content-secondary-bg-primary': !value,
        })}
      >
        <Tooltip
          content={textValue}
          placement="top"
          maxWidth={toolTipWidth}
          isDisabled={textValue.length <= MAX_TEXT_LENGTH}
        >
          {displayText}
        </Tooltip>
      </div>
    </div>
  );
};
